import Poller from "../Poller/Poller";

export default new Poller();
